import { Box, Divider, Stack, Link as MuiLink } from '@mui/material'
import { Link } from 'react-router-dom'
import { PRIVACY_POLICY, TERMS_OF_USE } from '@common/constants/routes'
import { Typography, ContainerBottom } from './footer.styles'

const Footer = () => {
  return (
    <Box sx={{ backgroundColor: '#0C0F13', position: 'relative' }}>
      <Divider sx={{ backgroundColor: 'rgb(180,180,180)' }} />
      <ContainerBottom
        sx={{
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: 'flex-start',
          gap: { xs: 0, sm: 2 },
          p: 2,
        }}
      >
        <Typography variant='caption' color='rgb(180,180,180)'>
          All rights reserved © <span>Pengguin Inc</span> 2025.
        </Typography>
        <Stack direction='row' alignItems='center' justifyContent='center' sx={{ flex: 1 }}>
          <Typography variant='caption' sx={{ fontSize: '12px' }}>
            AI feedback may contain errors. Click “thumbs down” on the feedback page if something
            seems off.
          </Typography>
        </Stack>
      </ContainerBottom>
    </Box>
  )
}

export default Footer
